import { render, staticRenderFns } from "./EocViewTreatmentPlanDocuments.vue?vue&type=template&id=07944c40&scoped=true&"
import script from "./EocViewTreatmentPlanDocuments.vue?vue&type=script&lang=js&"
export * from "./EocViewTreatmentPlanDocuments.vue?vue&type=script&lang=js&"
import style0 from "./EocViewTreatmentPlanDocuments.vue?vue&type=style&index=0&id=07944c40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07944c40",
  null
  
)

export default component.exports